import { getData } from './getData';
export const getAmbassadorDetailsData = async (endpoint) => {
    return await getData(endpoint).then(async (response) => {
        return response.data.ambassadorByPath.item;
    });
};
